export default __webpack_public_path__ + "static/media/CloudLightIcon.649fd2fe.svg";